import React, {Component} from 'react';
import Toggle from 'react-bootstrap-toggle';

import ObjectDisplay from 'components/ObjectDisplay'

const filterDateFields = (value, key) => {
  return !["visitedAt","createdAt","updatedAt"].includes(key);
}

const Details = props => {
  const {selected, toggleUserApproved} = props;
  return (
    <div>
      <Toggle onstyle="success" offstyle="warning" className="pull-right" active={selected.isApproved} onClick={toggleUserApproved(selected._id)} on="Approved" off="Not Approved" />
      <h3>User Details</h3>
      <ObjectDisplay object={props.selected} filterFunc={filterDateFields} />

    </div>
  );
};

import {toggleUserApproved} from 'actions/index'

import {initializer, selectors} from 'utils/resourcerizer';
import {connect} from 'react-redux';

import {USERS_NS} from 'constants/index';

const usersInitializer = initializer(USERS_NS)
const usersSelectors = selectors(USERS_NS)

const mstp = (state,ownProps) => ({
  selected: usersSelectors.findOneById(state,ownProps.userId)
})

const mdtp = dispatch => ({
  toggleUserApproved: (id) => () => dispatch(toggleUserApproved(id))
})

Details.Container = usersInitializer(connect(mstp,mdtp)(Details))

export default Details



// WEBPACK FOOTER //
// ./src/components/users/Details.jsx